export default __webpack_public_path__ + "static/media/mastercard.df992dc9.png";